import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "aura-composer relative flex h-full w-full min-w-0 bg-[#F5F6F8]" }
const _hoisted_2 = { class: "aura-composer-main min-h-0 min-w-0 flex-1 p-2 sm:p-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex h-full items-center justify-center rounded-2xl border border-[#F5F5F5] bg-white shadow-[0px_0px_0px_1px_rgba(23,23,23,0.05),0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] sm:rounded-3xl"
}
const _hoisted_4 = { class: "flex flex-col items-center gap-4 text-center" }
const _hoisted_5 = { class: "text-sm font-medium text-[#626468]" }
const _hoisted_6 = { class: "flex h-full items-center justify-center bg-[#F8FAFC] p-4 sm:p-6" }
const _hoisted_7 = { class: "w-full max-w-xl rounded-2xl border border-[#E5E7EB] bg-white p-5 text-center shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] sm:rounded-3xl sm:p-8" }
const _hoisted_8 = { class: "text-2xl font-bold text-[#242B59]" }
const _hoisted_9 = { class: "mx-auto mt-3 max-w-md text-sm leading-6 text-[#626468]" }
const _hoisted_10 = { class: "mt-6 rounded-2xl bg-[#F9FAFB] px-4 py-4 text-sm text-[#6B7280]" }
const _hoisted_11 = { class: "flex h-full min-h-0 min-w-0 flex-col overflow-hidden rounded-2xl border border-[#F5F5F5] bg-white shadow-[0px_0px_0px_1px_rgba(23,23,23,0.05),0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] sm:rounded-3xl" }
const _hoisted_12 = {
  key: 0,
  class: "px-4 pt-4 sm:px-6"
}
const _hoisted_13 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_14 = { class: "min-h-0 min-w-0 flex-1 overflow-hidden" }
const _hoisted_15 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_16 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_17 = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4" }
const _hoisted_18 = { class: "sm:flex sm:items-start" }
const _hoisted_19 = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = { class: "text-sm text-gray-500" }
const _hoisted_22 = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSpinner = _resolveComponent("UiSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Sidebar: History and conversation list (only when AURA is available) "),
    ($setup.isAuraAvailable && $setup.canViewHistory && $setup.isMobile && $setup.sidebarOpen)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "fixed inset-0 z-40 cursor-default bg-[#242B59]/35 backdrop-blur-[1px]",
          "aria-label": "Fechar histórico de conversas",
          onClick: $setup.closeSidebar
        }))
      : _createCommentVNode("v-if", true),
    ($setup.isAuraAvailable && $setup.canViewHistory)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
                'z-50 h-full flex-shrink-0 transition-transform duration-200 ease-out',
                $setup.isMobile
                    ? [
                          'fixed inset-y-0 left-0 shadow-2xl',
                          $setup.sidebarOpen ? 'translate-x-0' : '-translate-x-full',
                      ]
                    : 'relative translate-x-0',
            ])
        }, [
          _createVNode($setup["AuraSidebar"], {
            "is-history-loading": $setup.isHistoryLoading,
            onSelect: _cache[0] || (_cache[0] = ($event: any) => {
                    $setup.handleSelectConversation($event);
                    $setup.closeSidebar();
                }),
            onCreate: _cache[1] || (_cache[1] = ($event: any) => {
                    $setup.handleCreateConversation();
                    $setup.closeSidebar();
                }),
            onDelete: $setup.handleDeleteConversation
          }, null, 8 /* PROPS */, ["is-history-loading"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Main chat area "),
    _createElementVNode("main", _hoisted_2, [
      _createCommentVNode(" Initial loading state "),
      ($setup.isContextLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_UiSpinner, { class: "h-10 w-10 text-[#242B59]" }),
              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.loadingMessage), 1 /* TEXT */)
            ])
          ]))
        : (!$setup.isAuraAvailable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Access denied state "),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#EEF2FF]" }, [
                    _createElementVNode("div", { class: "flex h-10 w-10 items-center justify-center rounded-full bg-[#242B59] text-xl text-white" }, " 🔒 ")
                  ], -1 /* CACHED */)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mx-auto mb-3 inline-flex items-center rounded-full bg-[#E6F9F5] px-3 py-1.5" }, [
                    _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-[0.16em] text-[#242B59]" }, " mobcall AURA™ ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.t('aura.accessDenied.title')), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_9, _toDisplayString($setup.t('aura.accessDenied.message')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.t('aura.chat.disclaimer')), 1 /* TEXT */)
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Chat content (only with permission) "),
              _createElementVNode("div", _hoisted_11, [
                _createCommentVNode(" Header with branding and active filters "),
                _createVNode($setup["AuraHeader"], {
                  "vertical-name": $setup.auraContext?.linkedVertical?.verticalName,
                  "show-menu": $setup.canViewHistory,
                  compact: $setup.isMobile,
                  onMenu: $setup.openSidebar
                }, null, 8 /* PROPS */, ["vertical-name", "show-menu", "compact"]),
                ($setup.validationError || $setup.temporalConflict)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      ($setup.validationError)
                        ? (_openBlock(), _createBlock($setup["AuraValidationMessage"], {
                            key: 0,
                            "error-type": $setup.validationError.type as any,
                            message: $setup.validationError.message,
                            suggestion: $setup.validationError.suggestion,
                            dismissible: "",
                            onDismiss: $setup.handleDismissValidationError
                          }, null, 8 /* PROPS */, ["error-type", "message", "suggestion"]))
                        : _createCommentVNode("v-if", true),
                      ($setup.temporalConflict)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode($setup["TemporalWarning"], {
                              conflict: $setup.temporalConflict,
                              onAutoCorrect: $setup.handleAutoCorrect,
                              onManualEdit: $setup.handleManualEdit,
                              onProceed: $setup.handleProceed,
                              onRephrase: $setup.handleRephrase,
                              onDismiss: $setup.handleDismissTemporalWarning
                            }, null, 8 /* PROPS */, ["conflict"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Chat content "),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode($setup["AuraChatLayout"], {
                    ref: "chatLayoutRef",
                    messages: $setup.messages,
                    "is-loading": $setup.isInternalLoading,
                    "empty-prompts": $setup.suggestedQuestions,
                    "context-title": $setup.auraContext?.linkedVertical?.verticalName ?? '',
                    "loading-message": $setup.loadingMessage,
                    onSend: $setup.handleSendMessage,
                    onRetryFailedQuestion: $setup.handleRetryFailedQuestion,
                    onSendWithFilter: $setup.handleSendWithFilter
                  }, null, 8 /* PROPS */, ["messages", "is-loading", "empty-prompts", "context-title", "loading-message"])
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]),
    _createCommentVNode(" Delete confirmation dialog "),
    _createVNode($setup["TransitionRoot"], {
      as: "template",
      show: $setup.deleteDialogOpen
    }, {
      default: _withCtx(() => [
        _createVNode($setup["Dialog"], {
          as: "div",
          class: "relative z-50",
          onClose: $setup.cancelDeleteConversation
        }, {
          default: _withCtx(() => [
            _createVNode($setup["TransitionChild"], {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1 /* CACHED */)
              ])),
              _: 1 /* STABLE */,
              __: [4]
            }),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode($setup["TransitionChild"], {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["DialogPanel"], { class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                              _createElementVNode("svg", {
                                class: "h-6 w-6 text-red-600",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "1.5",
                                stroke: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                })
                              ])
                            ], -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode($setup["DialogTitle"], {
                                as: "h3",
                                class: "text-base font-semibold leading-6 text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('aura.conversation.deleteTitle')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("p", _hoisted_21, _toDisplayString($setup.t('aura.conversation.deleteMessage', {
                                                            title:
                                                                $setup.conversationToDelete?.title ||
                                                                'Untitled',
                                                        })), 1 /* TEXT */)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto",
                            onClick: $setup.confirmDeleteConversation
                          }, _toDisplayString($setup.t('aura.conversation.confirm')), 1 /* TEXT */),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto",
                            onClick: $setup.cancelDeleteConversation
                          }, _toDisplayString($setup.t('aura.conversation.cancel')), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ]))
}